function Uniform() {
  return (
    <section className="py-16 px-6 bg-gray-50">
      <div className="max-w-7xl mx-auto">

        <h1 className="text-4xl font-bold text-blue-900 mb-10 text-center">
          School Uniform
        </h1>

        {/* Pre Primary */}
        <div className="bg-white p-6 rounded-2xl shadow mb-8">
          <h2 className="text-xl font-bold text-yellow-500 mb-4">
            Pre-Nursery to UKG
          </h2>

          <p><strong>Girls:</strong> Red/Blue T-shirt with blue pinafore, black shoes.</p>
          <p><strong>Boys:</strong> Red/Blue T-shirt with denim shorts, black shoes.</p>
        </div>

        {/* Grade 1-3 */}
        <div className="bg-white p-6 rounded-2xl shadow mb-8">
          <h2 className="text-xl font-bold text-yellow-500 mb-4">
            Grade I to III
          </h2>

          <p>Red/Blue T-shirt with blue uniform. White uniform on Wednesdays.</p>
          <p>Yoga uniform when required.</p>
        </div>

        {/* Grade 4 */}
        <div className="bg-white p-6 rounded-2xl shadow mb-8">
          <h2 className="text-xl font-bold text-yellow-500 mb-4">
            Grade IV
          </h2>

          <p>Light blue shirt with navy blue bottom.</p>
          <p>House uniform on Wednesday.</p>
        </div>

        {/* Grade 5-6 */}
        <div className="bg-white p-6 rounded-2xl shadow">
          <h2 className="text-xl font-bold text-yellow-500 mb-4">
            Grade V to VI
          </h2>

          <p>Formal uniform with blazer (except Wed & Sat).</p>
          <p>House uniform on Wed & Sat.</p>
          <p>Scouts & Guides uniform when applicable.</p>
        </div>

      </div>
    </section>
  );
}

export default Uniform;